// 10 new Phases tailored for Majhong - mirrored from backend
export const PHASES = {
  1: {
    name: "6 Cards of Same Suit",
    requirements: [
      { type: 'color', count: 6, label: 'Same Suit' }
    ],
    totalCards: 6,
    description: "Requires 6 cards of the same suit. Easy to build and hit!"
  },
  2: {
    name: "7 Even Cards",
    requirements: [
      { type: 'anyEven', count: 7, label: 'Evens' }
    ],
    totalCards: 7,
    description: "Requires 7 even-numbered cards of any suit."
  },
  3: {
    name: "5 Same Suit + 1 Word Pair",
    requirements: [
      { type: 'color', count: 5, label: 'Same Suit' },
      { type: 'wordSet', count: 2, label: 'Word Pair' }
    ],
    totalCards: 7,
    description: "Requires 5 cards of the same suit and 1 Pair of identical Word/Honor cards."
  },
  4: {
    name: "1 Run of 5 + 1 Pair",
    requirements: [
      { type: 'colorRun', count: 5, label: 'Suit Run' },
      { type: 'set', count: 2, label: 'Pair' }
    ],
    totalCards: 7,
    description: "Requires a consecutive Run of 5 cards of the same suit, plus 1 Pair."
  },
  5: {
    name: "3 Sets of 3 (Pungs)",
    requirements: [
      { type: 'set', count: 3, label: 'Pung' },
      { type: 'set', count: 3, label: 'Pung' },
      { type: 'set', count: 3, label: 'Pung' }
    ],
    totalCards: 9,
    description: "Requires 3 different Sets of 3 identical tiles (Pungs)."
  },
  6: {
    name: "5 Terminals + 1 Pung",
    requirements: [
      { type: 'terminals', count: 5, label: 'Terminals' },
      { type: 'set', count: 3, label: 'Pung' }
    ],
    totalCards: 8,
    description: "Requires 5 Terminal cards (1s or 9s of any suit) and 1 Set of 3 identical tiles (Pung)."
  },
  7: {
    name: "1 Long Run of 7",
    requirements: [
      { type: 'colorRun', count: 7, label: 'Long Run' }
    ],
    totalCards: 7,
    description: "Requires a consecutive Long Run of 7 cards all belonging to the exact same suit."
  },
  8: {
    name: "1 Kong (4) + 2 Pairs",
    requirements: [
      { type: 'set', count: 4, label: 'Kong' },
      { type: 'set', count: 2, label: 'Pair' },
      { type: 'set', count: 2, label: 'Pair' }
    ],
    totalCards: 8,
    description: "Requires 1 Kong (4 identical tiles) and 2 Pairs."
  },
  9: {
    name: "7 Same Suit + 1 Word Pung",
    requirements: [
      { type: 'color', count: 7, label: 'Same Suit' },
      { type: 'wordSet', count: 3, label: 'Word Pung' }
    ],
    totalCards: 10,
    description: "Extreme Challenge: Collect 7 cards of the exact same suit plus 1 Pung consisting entirely of Word/Honor cards."
  },
  10: {
    name: "1 Run of 5 + 1 Pung + 1 Pair",
    requirements: [
      { type: 'colorRun', count: 5, label: 'Suit Run' },
      { type: 'set', count: 3, label: 'Pung' },
      { type: 'set', count: 2, label: 'Pair' }
    ],
    totalCards: 10,
    description: "The Ultimate Hand! Needs a 5-card consecutive suit Run, one Pung (3 identical), and one Pair (2 identical)."
  }
};

// Game mode descriptions
export const GAME_MODES = {
  normal10: {
    name: 'Normal Phase 10',
    description: 'Complete phases 1-10 in order',
    maxPhase: 10
  },
  choice10: {
    name: 'Choice Phase 10',
    description: 'Choose which phase to attempt each round (1-10)',
    maxPhase: 10
  },
  chaos10: {
    name: 'Chaos Phase 10',
    description: 'Random phase assigned each round (1-10)',
    maxPhase: 10
  },
  normal20: {
    name: 'Normal Phase 20',
    description: 'Complete phases 1-20 in order',
    maxPhase: 20
  },
  choice20: {
    name: 'Choice Phase 20',
    description: 'Choose which phase to attempt each round (1-20)',
    maxPhase: 20
  },
  chaos20: {
    name: 'Chaos Phase 20',
    description: 'Random phase assigned each round (1-20)',
    maxPhase: 20
  },
  normal30: {
    name: 'Normal Phase 30',
    description: 'Complete phases 1-30 in order',
    maxPhase: 30
  },
  choice30: {
    name: 'Choice Phase 30',
    description: 'Choose which phase to attempt each round (1-30)',
    maxPhase: 30
  },
  chaos30: {
    name: 'Chaos Phase 30',
    description: 'Random phase assigned each round (1-30)',
    maxPhase: 30
  }
};

// Get phase info
export function getPhaseInfo(phaseNumber) {
  return PHASES[phaseNumber] || null;
}

// Get available phases for a mode
export function getPhasesForMode(mode) {
  const modeInfo = GAME_MODES[mode];
  if (!modeInfo) return [];

  const phases = [];
  for (let i = 1; i <= modeInfo.maxPhase; i++) {
    phases.push(i);
  }
  return phases;
}

export default PHASES;
